class BundleBuilder extends HTMLElement {
  static MOBILE_HEADER = 110;
 constructor() {
   super();
   this.confirmBtns = this.querySelectorAll('.bundle-builder__confirm');
   this.addToCartBtn = this.querySelector('.bundle-builder-add-to-cart');
   this.addRow = this.querySelector('.bundle-builder__add-row');
   this.removeIcons = this.querySelectorAll('.icon-remove');
   this.mainRowsContainer = this.querySelector('.bundle-builder__rows');
   this.moreRowsContainer = this.querySelector('.bundle-builder__more-rows');
   this.addRowsIndexEl = this.addRow?.querySelector('.add-row__title-index');
   this.savingsMessage = this.querySelector('.bundle-builder__savings-message');
   this.styleIcons = this.querySelectorAll('.style-icon');
   this.multiTiresBtns = this.querySelectorAll('.multi-tires__btn');
   this.ignorePackImageSwap = false;
   this.currencyPrefix = this.dataset.currencyPrefix || '';
   this.confirmBtns.forEach(btn => {
     btn.addEventListener('click', this.onConfirmBtnClick.bind(this));
   })
   this.addToCartBtn.addEventListener('click', this.onAddToCartBtnClick.bind(this));
   this.addRow?.addEventListener('click', this.onAddRowClick.bind(this));
   this.removeIcons.forEach(icon => {
     icon.addEventListener('click', this.onRemoveIconClick.bind(this));
   })
   this.styleIcons.forEach(icon => {
     icon.addEventListener('click', this.onStyleIconClick.bind(this));
   })
   this.multiTiresBtns.forEach(btn => {
     btn.addEventListener('click', this.onMultiTiresBtnClick.bind(this));
   })
   window.addEventListener('load', () => {
     const params = new URLSearchParams(window.location.search);
     const pack   = params.get('pack');
     if (!pack) {
        this.classList.remove("loading"); return;
     };
     const btn = this.querySelector(`.multi-tires__btn[data-items="${pack}"]`);
     if (btn) btn.click();
     this.classList.remove("loading");
   });
   document.addEventListener('DOMContentLoaded', this.singlesAndPacksSavings.bind(this));
   document.addEventListener('DOMContentLoaded', this.initialPackPrice.bind(this));
   this.addEventListener('bundle-row-clicked', () => {
     this.ignorePackImageSwap = true;
   });
   this.updateAddRowTitle();
 }

 static scrollOffset () {
   return 80;
 }

 static scrollRowHeaderIntoView (headerEl, offsetPx = 0, smooth = true) {
   if (!headerEl) return;
 
   /* ───────── phones: whole document scrolls ───────── */
   if (matchMedia('(max-width: 749px)').matches) {
     const y = headerEl.getBoundingClientRect().top + window.scrollY - offsetPx;
     window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
     return;
   }
 
   /* ───────── desktops: find inner scroll pane ─────── */
   const root = document.scrollingElement || document.documentElement;
   let   container = headerEl.parentElement;
 
   while (container && container !== root &&
          container.scrollHeight <= container.clientHeight) {
     container = container.parentElement;
   }
   if (!container) container = root;
 
   /* target position inside that pane */
   const cRect  = container.getBoundingClientRect();
   const hRect  = headerEl.getBoundingClientRect();
   const target = (hRect.top - cRect.top) + container.scrollTop - offsetPx;
 
   const isiOS       = /iP(ad|hone|od)/.test(navigator.userAgent) && !window.MSStream;
   const wantsSmooth = smooth && !isiOS;
 
   if (isiOS && container !== root) container.style.webkitOverflowScrolling = 'touch';
 
   if (container === root) {
     window.scrollTo({ top: target, behavior: wantsSmooth ? 'smooth' : 'auto' });
   } else if (isiOS) {
     headerEl.scrollIntoView({ block: 'start', behavior: 'smooth' });
     if (offsetPx) requestAnimationFrame(() =>
       container.scrollBy({ top: -offsetPx, behavior: 'auto' }));
   } else {
     container.scrollTo({ top: target, behavior: wantsSmooth ? 'smooth' : 'auto' });
   }
 }
 

 onConfirmBtnClick(e) {
  const btn = e.currentTarget;

  /* ---------- 1. locate the <bundle-builder-row> ---------- */
  let thisRow = btn.closest('bundle-builder-row');
  if (!thisRow) {
    const outer = btn.closest('.bundle-builder-row__outer');
    thisRow = outer ? outer.querySelector('bundle-builder-row') : null;
  }
  if (!thisRow) {
    console.warn(
      'Confirm button is not inside a <bundle-builder-row>. ' +
      'Check your template or wrappers.'
    );
    return;
  }

  /* ---------- 2. house-keeping ---------- */
  const thisStep     = btn.closest('.bundle-builder-step');
  const thisRowIndex = Number(thisRow.dataset.index);
  const nextRow      = thisRow.closest('.bundle-builder__rows')
                       ?.querySelector(
                         `bundle-builder-row[data-index="${thisRowIndex + 1}"]`
                       ) || null;

  if (thisStep) {
    const counter = thisStep.querySelector('.selected-counter');
    if (counter && Number(counter.textContent) < thisRowIndex) {
      counter.textContent = thisRowIndex;                 // bump header counter
    }
  }

  /* ---------- 3. still rows left in this step ---------- */
  if (nextRow) {
    const isMobile = matchMedia('(max-width:749px)').matches;

    /* 3a. collapse current row */
    thisRow.classList.remove('to-select');
    thisRow.header.click();

    /* 3b. prepare & open next row */
    nextRow.classList.remove('disabled');
    nextRow.classList.add('to-select');

    if (isMobile) {
      const body      = thisRow.querySelector('.bundle-builder__body');
      const openNext  = () => nextRow.header.click();
      body ? body.addEventListener('transitionend', openNext, { once: true })
           : openNext();                                  // no animation → open now
    } else {
      BundleBuilder.scrollRowHeaderIntoView(nextRow.header, 0, false);
      nextRow.header.click();
    }
    return;                                               // done for this click
  }

  /* ---------- 4. no next row – maybe another step? ---------- */
  if (thisStep) {
    const nextStep = thisStep.nextElementSibling;
    if (nextStep) {
      // close current row & step
      thisRow.classList.remove('to-select');
      thisRow.header.click();

      thisStep.classList.remove('to-select');
      thisStep.header.click();

      // activate next step
      nextStep.classList.remove('disabled');
      nextStep.classList.add('to-select');
      nextStep.header.click();
    } else {
      // last row of last step – enable Add-to-Cart
      this.onLastConfirmBtnClick(e);
    }
  } else {
    // safety net (shouldn’t happen)
    this.onLastConfirmBtnClick(e);
  }
}

 
 
 
 onLastConfirmBtnClick(e) {
   const thisRow = e.target.closest('.bundle-builder-row');
   const thisStep = e.target.closest('.bundle-builder-step');

   // 1. Close the current row
   thisRow.classList.remove('to-select');
   thisRow.header.click();

   // 2. Close the current step 
   if (thisStep) {
     thisStep.classList.remove('to-select');
     thisStep.header.click();
   }

   // 3. Activate add to cart button
   this.addToCartBtn.innerHTML = 'Add to cart';
   this.addToCartBtn.classList.remove('disabled');
 }

 onAddToCartBtnClick(e) {
   const btn = e.currentTarget;

   if (btn.classList.contains('disabled')) {
     this.highlightToSelectRow();
     this.highlightToSelectStep();
   } else {
     const forms = this.querySelectorAll("form#product-form");
     const variantItemList = {};
 
     forms.forEach((form) => {
       // Skip disabled rows
       const isDisabled = form.closest('.bundle-builder-row').classList.contains('disabled');
       if (isDisabled) return;

       // Skip hidden styles
       const styleForm = form.closest('.style-form');
       if (styleForm && styleForm.classList.contains('hidden')) return;
       
       const variantId = form.querySelector(".product-form__variant-id").value;
       
       if (variantItemList[variantId]) {
         variantItemList[variantId] = variantItemList[variantId] + 1;
       } else {
         variantItemList[variantId] = 1;
       }
     });
     
     const items = [];
     
     Object.keys(variantItemList).forEach((variantId, index) => {
       const quantity = variantItemList[variantId];
       const preorderLineItemProperty =
         document.querySelector(`.preorder__line-item-property input.variant--${variantId}`) ?
         document.querySelector(`.preorder__line-item-property input.variant--${variantId}`).value.trim() : false;
       const finalSaleLineItemProperty =
         document.querySelector(`.last-chance__line-item-property input.variant--${variantId}`) ?
         document.querySelector(`.last-chance__line-item-property input.variant--${variantId}`).value.trim() : false;
       const customLineItemPropertyEl = document.querySelector(`.custom-line-item-property input.variant--${variantId}`);
       const customLineItemPropertyTitle = customLineItemPropertyEl?.dataset.title;
       const customLineItemPropertyValue = customLineItemPropertyEl?.value.trim();
       
       items.push({
         quantity,
         id: variantId,
         properties: {}
       })
       
       if (preorderLineItemProperty) {
         items[index].properties["_Pre-order"] = preorderLineItemProperty;
       }
       
       if (finalSaleLineItemProperty) {
         items[index].properties["_LPROP"] = finalSaleLineItemProperty;
       }
       
       if (customLineItemPropertyEl) {
         items[index].properties[customLineItemPropertyTitle] = customLineItemPropertyValue;
       }
     });
 
     this.bundleBuilderATC(items);
   }
 }

 highlightToSelectRow() {
   const toSelectRow = document.querySelector('.bundle-builder-row.to-select');

   toSelectRow.classList.add('highlight-to-select');
   setTimeout(() => toSelectRow.classList.remove('highlight-to-select'), 1000);
 }

 highlightToSelectStep(){
   const toSelectStep = document.querySelector('.bundle-builder-step.to-select');
   if (!toSelectStep) return;

   toSelectStep.classList.add('highlight-to-select');
   setTimeout(() => toSelectStep.classList.remove('highlight-to-select'), 1000);
 }
 
 formatWithPrefix(amount) {
  const money = Shopify.formatMoney(amount).replace(/(\.|,)00\b/, '');
  return this.currencyPrefix ? this.currencyPrefix + money : money;
}

 updateAddRowTitle() {
   if (!this.addRow || !this.savingsMessage) return;

   const titleEl   = this.addRow.querySelector('.add-row__title');
   if (!titleEl) return;

   const indexSpan = titleEl.querySelector('.add-row__title-index');
   if (!indexSpan) return;                               

   const full      = Number(this.savingsMessage.dataset.productPriceOriginal);
   const activeBtn = this.querySelector('.multi-tires__btn.active');
   let   discount  = Number(this.savingsMessage.dataset.productPriceDiscount);
   if (activeBtn) discount = Number(activeBtn.dataset.pricePerItem);

   const extra     = full - discount;                    
   const formatted = Shopify.formatMoney(extra).replace(/(\.|,)00\b/, '');

   let noteSpan = titleEl.querySelector('.extra-savings-note');

   if (extra <= 0) {
     if (noteSpan) noteSpan.remove();
     return;
   }

   if (!noteSpan) {
     noteSpan = document.createElement('span');
     noteSpan.className = 'extra-savings-note';
     indexSpan.after(noteSpan);                          
   }

   noteSpan.textContent = ` – save an extra ${formatted}!`;
 }

 bundleBuilderATC(items) {
   const cart = document.querySelector("cart-drawer");
   const cartCounterIcon = document.querySelector(".header__icon--cart-wrapper");
 
   // Add loading animation
   this.addToCartBtn.classList.add('loading');
   cartCounterIcon.classList.add('loading');
 
   let formData = {};
 
   if (cart) {
     formData["sections"] = cart.getSectionsToRender().map((section) => section.id);
     formData["sections_url"] = window.location.pathname;
     formData["items"] = items;
     cart.setActiveElement(document.activeElement);
   }
 
   fetch(window.Shopify.routes.root + "cart/add.js", {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
     },
     body: JSON.stringify(formData),
   })
   .then((response) => response.json())
   .then((response) => {
     cart.renderContents(response);
     cart.openCloseCart();
   })
   .catch((error) => {
     console.error("Error:", error);
   })
   .finally(() => {
     if (cart && cart.classList.contains("is-empty")) {
       cart.classList.remove("is-empty");
     }

     // Remove loading animation
     this.addToCartBtn.classList.remove('loading');
     cartCounterIcon.classList.remove('loading');
   });
 }
 
 onAddRowClick() {
   const addRowsIndexNumber = parseInt(this.addRowsIndexEl.textContent);
   const toAddRowOuter = this.moreRowsContainer.firstElementChild;
   if (!toAddRowOuter) return;
   const toAddRow = toAddRowOuter.querySelector('.bundle-builder-row')
   const toSelectRow = document.querySelector('.bundle-builder-row.to-select');
   
   // 1. If there's no to-select row, make this new row to-select and disable ATC button
   if (!toSelectRow) {
     toAddRow.classList.remove('disabled');
     toAddRow.classList.add('to-select');
     this.addToCartBtn.classList.add('disabled');
   }

   // 2. Move the new row to the main rows container
   this.mainRowsContainer.insertAdjacentElement('beforeend', toAddRowOuter);

   // 3. Show/hide remove icon
   this.showHideRemoveIcons();

   // 4. Display the new row
   toAddRowOuter.classList.remove('hidden');

   // 5. Increment the add row index 
   this.addRowsIndexEl.textContent = addRowsIndexNumber + 1;

   // 6. Hide add row element if there are no more rows
   if (!this.moreRowsContainer.firstElementChild) this.addRow.classList.add('hidden');

   // 7. Update multi-tires buttons
   this.updateMultiTiresBtns();

   // 8. Re-calc the savings
   this.calcSavings();

   // 9. Update pack price
   this.updatePackPrice();

   // 10. Show discount amount
   this.updateAddRowTitle();
 }

 showHideRemoveIcons() {
   const addedRows = this.mainRowsContainer.querySelectorAll('.bundle-builder-row__outer');
   if (addedRows.length === 0) return;
   addedRows.forEach(row => row.classList.remove('show-remove-icon'));
   addedRows[addedRows.length - 1].classList.add('show-remove-icon');
 }

 onRemoveIconClick(e) {
   const addRowsIndexNumber = parseInt(this.addRowsIndexEl.textContent);
   const toRemoveRowOuter = e.target.closest('.bundle-builder-row__outer');
   const toRemoveRow = toRemoveRowOuter.querySelector('.bundle-builder-row');
   const selectedVariantEl = toRemoveRow.querySelector('.bundle-builder-row__selected-variant');

   // 1. Move the row from the main rows container to the more rows container
   this.moreRowsContainer.insertAdjacentElement('afterbegin', toRemoveRowOuter);

   // 2. Hide and disable it
   toRemoveRowOuter.classList.add('hidden');
   toRemoveRow.classList.remove('to-select');
   toRemoveRow.classList.add('disabled');
   selectedVariantEl.textContent = '';

   // 3. Update add row index and show it
   this.addRowsIndexEl.textContent = addRowsIndexNumber - 1;
   this.addRow.classList.remove('hidden');

   // 4. Show/hide remove icon
   this.showHideRemoveIcons();

   // 5. Check to-select row
   const toSelectRow = document.querySelector('.bundle-builder-row.to-select');
   if (!toSelectRow) {
     this.addToCartBtn.innerHTML = 'Add to cart';
     this.addToCartBtn.classList.remove('disabled');
   }

   // 7. Update multi-tires buttons
   this.updateMultiTiresBtns();

   // 8. Re-calc the savings
   this.calcSavings();

   // 9. Update pack price
   this.updatePackPrice();

   // 10. Show discount amount
   this.updateAddRowTitle();
 }

 calcSavings() {
  const numberOfItems = this.mainRowsContainer.childElementCount;

  const originalUnitCents = Number(this.savingsMessage.dataset.productPriceOriginal);
  let   discountUnitCents = Number(this.savingsMessage.dataset.productPriceDiscount);

  this.multiTiresBtns.forEach(btn => {
    if (btn.classList.contains('active')) {
      discountUnitCents = Number(btn.dataset.pricePerItem);
    }
  });

  const totalCents   = discountUnitCents * numberOfItems;
  const savingsCents = (originalUnitCents * numberOfItems) - totalCents;

  const totalEl   = this.savingsMessage.querySelector('.total');
  const savingsEl = this.savingsMessage.querySelector('.savings');

  totalEl.textContent = this.formatWithPrefix(totalCents);
  if (savingsEl) savingsEl.textContent = this.formatWithPrefix(savingsCents);
}


 onStyleIconClick(e) {
   const styleIcon = e.target.closest('.style-icon');
   const thisRow = styleIcon.closest('.bundle-builder-row');
   const allForms = thisRow.querySelectorAll('.style-form');
   const relatedForm = thisRow.querySelector(styleIcon.dataset.form);
   const variantRadiosEl = relatedForm.querySelector('variant-radios');

   // stopImmediatePropagation
   const input = styleIcon.querySelector('input[type="radio"]');
   input.addEventListener('click', function (e) {
     e.stopImmediatePropagation();
   })

   // 1. Show related form
   allForms.forEach((form) => form.classList.add('hidden'));
   relatedForm.classList.remove('hidden');

   // 2. Upate info
   variantRadiosEl.getSelectedOptions();
   variantRadiosEl.getVariantJSON();
   variantRadiosEl.getSelectedVariant();
   variantRadiosEl.updateProductInfo();
   variantRadiosEl.updateBundleBuilder();
 }

 onMultiTiresBtnClick(e) {
   const btn = e.currentTarget;
   const requiredNumberOfRows = parseInt(btn.dataset.items);
   const currentNumberOfRows = this.mainRowsContainer.childElementCount;
   const multiTiresCount = this.multiTiresBtns.length;  // total multi-tires buttons
 
    //change the page title with the new count
    document.title = document.title.replace(/\d+/, requiredNumberOfRows);

   // Check if a 5-pack button exists anywhere on the page
   const hasFivePackBtn = Array.from(this.multiTiresBtns).some(el => el.dataset.items === "5");
 
   this.multiTiresBtns.forEach(el => el.classList.remove('active'));
   btn.classList.add('active');
 
   if (requiredNumberOfRows > currentNumberOfRows) {
     const difference = requiredNumberOfRows - currentNumberOfRows;
     for (let index = 0; index < difference; index++) {
       this.addRow.click();
     }
   } else if (requiredNumberOfRows < currentNumberOfRows) {
     const difference = currentNumberOfRows - requiredNumberOfRows;
     for (let index = 0; index < difference; index++) {
       const removeIconsInTheMainRowsContainer = this.mainRowsContainer.querySelectorAll('.icon-remove');
       const lastRemoveIcon = removeIconsInTheMainRowsContainer[removeIconsInTheMainRowsContainer.length - 1];
       lastRemoveIcon.click();
     }
   }
 
   this.swapPictureSources(btn.dataset.image);

   this.updateAddRowTitle();
 }
 
 swapPictureSources(imageUrl) {
   // 1) find the very first slide in the slider
   const slide = document.querySelector('.product-media__gallery--slider .keen-slider__slide');
   if (!slide) return;
 
   // 2) inside that slide, find the <picture> block
   const picture = slide.querySelector('picture');
   if (!picture) return;
 
   // 3) swap every <source> srcset to the new URL
   picture.querySelectorAll('source').forEach(src => {
     // keep the " 1x" or " 2x" suffix if you want; here we just use 1x
     src.srcset = imageUrl + ' 1x';
   });
 
   // 4) swap the <img> itself
   const img = picture.querySelector('img.image-cover');
   if (!img) return;
   img.src = imageUrl;
   img.srcset = '';
   img.setAttribute('data-zoom', imageUrl.replace(/(\.\w+)(\?.*)?$/, '_2000x$1$2'));
 }

 updateMultiTiresBtns() {
   if (this.multiTiresBtns.length === 0) return;
   const currentNumberOfRows = this.mainRowsContainer.childElementCount;

   this.multiTiresBtns.forEach(btn => {
     const btnItems = parseInt(btn.dataset.items);

     if (currentNumberOfRows >= btnItems) {
       this.multiTiresBtns.forEach(el => el.classList.remove('active'));
       btn.classList.add('active');
     }
   })
 }

 singlesAndPacksSavings() {
   const holderEl = document.querySelector('.singles-and-packs__savings-holder');
   if (!holderEl) return;
   const savingsEls = document.querySelectorAll('.singles-and-packs__savings');

   holderEl.textContent = this.savingsMessage.dataset.singlesAndPacksSavings;
   savingsEls.forEach(el => el.textContent = holderEl.textContent);
 }

 toCents(priceText) {
  const txt = priceText.trim();
  if (/[.,]\d{2}\b/.test(txt)) {
    return Number(txt.replace(/[^\d]/g, '')); 
  }
  return Number(txt.replace(/[^\d]/g, '')) * 100;
}

 initialPackPrice() {
   const packPrice = document.querySelectorAll('.pack-price');
   if (!packPrice.length > 0) return;
   const initialPackPrice = this.savingsMessage.querySelector('.total');

   const first = this.formatWithPrefix(
      this.toCents(this.savingsMessage.querySelector('.total').textContent)
   );
     packPrice.forEach(price => price.textContent = first);
 }

 updatePackPrice() {
   const singlePrice = document.querySelectorAll('.product-price');
   const packPrice = document.querySelectorAll('.pack-price');
   const currentPackPrice = this.savingsMessage.querySelector('.total');
   const savingsLabel = document.querySelectorAll('.product-price__saving-label');
   const currentSavings = this.savingsMessage.querySelector('.savings');
 
   // Helper function to remove trailing .00 or ,00 if present
   function formatPrice(priceText) {
     priceText = priceText.trim();
     return priceText.replace(/(\.|,)00\b/, '');
   }
 
   // 1. Pack price - update text content with formatted price
   if (currentPackPrice) {
    const cents = this.toCents(currentPackPrice.textContent);
    const formattedPrice = this.formatWithPrefix(cents);
    packPrice.forEach(el => (el.textContent = formattedPrice));
   }
 
   singlePrice.forEach(price => price.classList.add('hidden'));
   packPrice.forEach(price => price.classList.remove('hidden'));
 
   // 2. Savings label
   if (savingsLabel.length > 0) {
     savingsLabel.forEach(label => {
       if (currentSavings) {
         const formattedSavings = formatPrice(currentSavings.textContent);
         label.textContent = `Save ${formattedSavings}`;
       } else {
         label.classList.add('hidden');
       }
     });
   }
 }
 
 
 
}

customElements.define('bundle-builder', BundleBuilder)

class BundleBuilderRow extends HTMLElement {
 constructor() {
   super();
   this.header = this.querySelector('.bundle-builder-row__header');
   this.body = this.querySelector('.bundle-builder__body');

   this.header.addEventListener('click', this.onHeaderClick.bind(this));
   window.addEventListener('resize', this.heightAnimation.bind(this));
 }
 onHeaderClick() {
   // 1) If this row is disabled, flash and bail
   if (this.classList.contains('disabled')) {
     this.highlightToSelectRow();
     return;
   }
 
   // 2) Collapse every other row
   document.querySelectorAll('bundle-builder-row').forEach(row => {
     if (row !== this) {
       row.classList.remove('active');
       row.body.style.maxHeight = '0';
     }
   });
 
   // 3) Toggle this one open
   const opening = !this.classList.contains('active');
   if (opening) {
     this.classList.add('active');
     this.updateRowInfo();
     this.heightAnimation();
   
     const offset = matchMedia('(max-width:749px)').matches
                    ? BundleBuilder.MOBILE_HEADER
                    : 0;
   
     BundleBuilder.scrollRowHeaderIntoView(this.header, offset);
   } else {
     // 4) closing
     this.classList.remove('active');
     this.body.style.maxHeight = '0';
   }
 
   // 5) bubble up so bundle-builder knows we clicked
   this.dispatchEvent(new CustomEvent('bundle-row-clicked', { bubbles: true }));
 }
 

 heightAnimation() {
   const innerH = getComputedStyle(this.querySelector('.bundle-builder__body-inner')).height;
 
   if (this.classList.contains('active')) {
     this.body.style.maxHeight = innerH;
   } else {
     this.body.style.maxHeight = '0';
   }
 }
 

 highlightToSelectRow() {
   const toSelectRow = document.querySelector('.bundle-builder-row.to-select');

   toSelectRow.classList.add('highlight-to-select');
   setTimeout(() => toSelectRow.classList.remove('highlight-to-select'), 1000);
 }

 updateRowInfo() {
   const styleForms = this.querySelector('.product-style__style-forms');
   let variantRadiosEl;
   
   if (styleForms) {
     variantRadiosEl = this.querySelector('.style-form:not(.hidden)').querySelector('variant-radios');
   } else {
     variantRadiosEl = this.querySelector('variant-radios');
   }

   variantRadiosEl.getSelectedOptions();
   variantRadiosEl.getVariantJSON();
   variantRadiosEl.getSelectedVariant();
   variantRadiosEl.updateProductInfo();
   variantRadiosEl.updateBundleBuilder();
 }
}

customElements.define('bundle-builder-row', BundleBuilderRow);

class BundelBuilderStep extends HTMLElement {
 constructor() {
   super();
   this.header = this.querySelector('.bundle-builder-step__header');
   this.body = this.querySelector('.bundle-builder-step__body');

   this.header.addEventListener('click', this.onHeaderClick.bind(this));
 }

 onHeaderClick() {
   if (this.classList.contains('disabled')) {
     this.highlightToSelectStep();
   } else {
     const allSteps = document.querySelectorAll('.bundle-builder-step');
 
     // 1. Show/hide current step
     if (this.classList.contains('active')) {
       this.classList.remove('active');
     } else {
       allSteps.forEach(el => el.classList.remove('active'));
       this.classList.add('active');
     }
   }
 }

 highlightToSelectStep(){
   const toSelectStep = document.querySelector('.bundle-builder-step.to-select');
   if (!toSelectStep) return;

   toSelectStep.classList.add('highlight-to-select');
   setTimeout(() => toSelectStep.classList.remove('highlight-to-select'), 1000);
 }

}

customElements.define('bundle-builder-step', BundelBuilderStep);